import * as React from 'react';
import { Grid } from '@material-ui/core';
import Box from "@material-ui/core/Box";
import Help from "../help/Help";
import { useEffect, useState } from "react";
import PickUpDate from "./PickUpDate";
import dayjs from "dayjs";
import useCommonApi from '../../api/useCommonApi';
import PickUpDateFueraHorario from './PickUpDateFueraHorario';
import moment from 'moment-timezone';
import swal from 'sweetalert2';
import { useSnackbar } from 'notistack';
import LoadingDialog from "../controls/LoadingDialog";
import { traducirLabel, traducirMessage } from '../../blocks/traductor';
import { ICliente } from '../../entities/catalogos/ICliente';
import { IRecoleccion } from '../../redux/types/recoleccionActionTypes';
import { enums } from '../../enums/enums';
import {
    aplicarCitaEadGuiaDestino,
    aplicarCitaFueraHorarioGuiaDestino,
    aplicarEntregaNormalGuiaDestino
} from './guiaRecoleccionOrigenHelpers';

interface Props {
    guiaOrigen: IRecoleccion;
    guiaDestino: IRecoleccion;
    cliente: ICliente;
    onChange: (destino: IRecoleccion) => void;
}

type CampoEntrega = '' | 'normal' | 'cita' | 'citaFueraHorario';

const RecoleccionFechaEntregaGuia = ({ guiaOrigen, guiaDestino, cliente, onChange }: Props) => {
    const apiSource = useCommonApi();
    const { enqueueSnackbar } = useSnackbar();

    const [dialogFecha, setDialogFecha] = useState(false);
    const [dialogFechaFueraHorario, setDialogFechaFueraHorario] = useState(false);
    const [fechaString, setFechaString] = useState(traducirMessage(227));
    const [fechaStringFueraHorario, setFechaStringFH] = useState(traducirMessage(226));
    const [horaString, setHoraString] = useState(traducirMessage(90));
    const [horaStringFH, setHoraStringFH] = useState(traducirMessage(90));
    const [campo, setCampo] = useState<CampoEntrega>('');
    const [selectedOption, setSelectedOption] = useState(1);
    const [seleccionaDefault, setSeleccionaDefault] = useState(false);
    const [showLoading, setLoading] = useState(false);
    const [ventanaFija, setVentanaFija] = useState({
        horaInicio: { hours: 0, minutes: 0 },
        horaFin: { hours: 0, minutes: 0 },
        lun: 0, mar: 0, mie: 0, jue: 0, vie: 0, sab: 0, dom: 0,
        ventanaEsp: "", ventanaIng: ""
    });
    const [aplicaReglasVentana, setAplicaReglasVentana] = useState(false);
    const [ventanaFijaRequest, setVentanaFijaRequest] = useState(false);
    const [valueCita, setValueCita] = useState<Date | undefined>(undefined);

    const areaServicio = guiaDestino.areaServicio;
    const horarios = areaServicio?.grupoHorarios;
    const horarioArea = areaServicio?.horarios;
    const aceptaCita = guiaDestino.aceptaCita && !guiaDestino.esServicioInternacional;
    const value = guiaDestino.fechaCita;
    const EsFueraHorario = guiaDestino.EsFueraHorario;
    const valueHoraDe = guiaDestino.horaFHDe;
    const valueHoraHasta = guiaDestino.horaFHHasta;
    const recintoAduanal = areaServicio?.recintoAduanal?.[0];
    const esRecintoAduanal = recintoAduanal?.tipoRecintoID === 1;
    const horaDeP = valueHoraDe ? new Date("2021-01-01 " + valueHoraDe + ":00") : new Date();
    const horaHastaP = valueHoraHasta ? new Date("2021-01-01 " + valueHoraHasta + ":00") : new Date();

    const validaInvitado = (): boolean => {
        if (localStorage["tipo_usuario"]?.toLowerCase() === "invitado") {
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(304),
                type: 'warning',
            });
            return false;
        }
        return true;
    };

    const validaFechaCita = (): boolean => {
        const mensaje = traducirMessage(202) + ' ' + (areaServicio?.nombre ?? '');
        if (areaServicio?.esEadConCita === false) {
            swal.fire({
                titleText: traducirMessage(276),
                text: mensaje,
                type: 'warning',
            });
            return false;
        }
        return true;
    };

    const validaFechaFueraHorario = (fecha: Date): boolean => {
        if (!areaServicio?.horarios?.length) {
            return true;
        }
        const date = moment(fecha);
        const hora = date.hours();
        const minuto = date.minutes();
        const day = date.isoWeekday();
        const dias: any[] = [];
        for (let i = 0; i < areaServicio.horarios.length; i++) {
            for (let j = 0; j < areaServicio.horarios[i].dias.length; j++) {
                dias.push({
                    id: areaServicio.horarios[i].dias[j].id,
                    fechaEntrada: moment(areaServicio.horarios[i].horaEntrada),
                    fechaSalida: moment(areaServicio.horarios[i].horaSalida)
                });
            }
        }
        const dia = dias.find(a => a.id === day);
        if (dia !== undefined) {
            const year = dia.fechaEntrada.year();
            const month = dia.fechaEntrada.month();
            const numeroDia = dia.fechaEntrada.date();
            const nuevaFecha = moment([year, month, numeroDia, hora, minuto]);
            if (nuevaFecha > dia.fechaSalida || nuevaFecha < dia.fechaEntrada) {
                return true;
            }
        } else {
            return true;
        }
        return false;
    };

    const validaMatriz = async (fecha: Date): Promise<boolean> => {
        const params = {
            clienteId: cliente.id,
            sucursalRemitenteId: guiaOrigen.sucursal?.id ?? 0,
            sucursalDestinatarioId: guiaDestino.sucursal?.id ?? 0,
            areaServicioRemitenteId: guiaOrigen.areaServicio?.id ?? 0,
            areaServicioDestinatarioId: guiaDestino.areaServicio?.id ?? 0,
            ocurreDestino: 0,
            destinatarioId: guiaDestino.distribuidor?.clienteDistribuidorID ?? guiaDestino.sucursal?.id ?? 0,
            sticker: "",
            cotizacionId: "",
            solicitudServicioId: "",
            fechaRecoleccion: guiaOrigen.fechaRecoleccion,
            tipoEnvioId: 1,
            fechaVentana: ""
        };

        const fechaCita = new Date(fecha);
        fechaCita.setMinutes(fecha.getMinutes() - fecha.getTimezoneOffset());
        const params2 = {
            tipo: "EAD",
            fecha: fechaCita,
            fechaEstimada: new Date(1900, 0, 1)
        };

        setLoading(true);
        try {
            if (params.sucursalDestinatarioId) {
                if (guiaOrigen.esComercioExterior && guiaOrigen.esServicioInternacional) {
                    params2.fechaEstimada = guiaOrigen.fechaRecoleccion ?? new Date(1900, 0, 1);
                } else {
                    const result = await apiSource.postAsync<any>("/solicitud-servicio/obtener-fecha-envio-estimado", params);
                    params2.fechaEstimada = new Date(result.fechA_FIN);
                    params2.fechaEstimada?.setMinutes(params2.fechaEstimada?.getMinutes() - params2.fechaEstimada.getTimezoneOffset());
                }
            }
            const result2 = await apiSource.postAsync<any>("/solicitud-servicio/verificar-fechas", params2);
            if (result2 !== "") {
                enqueueSnackbar(traducirMessage(parseInt(result2)), { variant: "warning" });
                return false;
            }
            return true;
        } finally {
            setLoading(false);
        }
    };

    const getVentanaFija = async () => {
        const distribuidorId = guiaDestino.distribuidor?.clienteDistribuidorID ?? guiaDestino.distribuidor?.id ?? 0;
        return await apiSource.obtenerAsync<any>(
            "solicitud-servicio/get-ventana-servicio?clienteId=" + cliente.id
            + "&distribuidorId=" + distribuidorId
            + "&servicioId=2"
        );
    };

    const actualizarEtiquetas = () => {
        let language = localStorage.getItem("idioma") === 'en-US' ? 'en' : 'es';
        const fechaCitaVal = value instanceof Date && value.getFullYear() === 1 ? undefined : value;
        let fs = fechaCitaVal && !EsFueraHorario
            ? dayjs(fechaCitaVal, { locale: language }).format(language === 'en' ? 'dddd MMM DD YYYY' : 'dddd DD MMM YYYY')
            : traducirMessage(227);
        let fsFh = fechaCitaVal && EsFueraHorario
            ? dayjs(fechaCitaVal, { locale: language }).format(language === 'en' ? 'dddd MMM DD YYYY' : 'dddd DD MMM YYYY')
            : traducirMessage(226);
        const hs = fechaCitaVal && !EsFueraHorario ? dayjs(fechaCitaVal).format('hh:mm A') : traducirMessage(90);
        const hsFh = fechaCitaVal && EsFueraHorario && valueHoraDe && valueHoraHasta
            ? dayjs(new Date("2021-01-01 " + valueHoraDe + ":00")).format('hh:mm A')
            + " - "
            + dayjs(new Date("2021-01-01 " + valueHoraHasta + ":00")).format('hh:mm A')
            : traducirMessage(90);

        setFechaString(fechaCitaVal
            ? (fs === traducirMessage(227) ? fs + traducirLabel(118) : fs)
            : traducirMessage(227) + traducirLabel(118));
        setFechaStringFH(fechaCitaVal
            ? (fsFh === traducirMessage(226) ? fsFh + traducirLabel(118) : fsFh)
            : traducirMessage(226) + traducirLabel(118));
        setHoraString(hs);
        setHoraStringFH(hsFh);
    };

    useEffect(() => {
        actualizarEtiquetas();
        if (guiaDestino.tipoDeRecoleccionDestino === 1) {
            setCampo('normal');
            setSelectedOption(1);
            setSeleccionaDefault(true);
        } else if (guiaDestino.tipoDeRecoleccionDestino === 2) {
            setCampo('cita');
            setSelectedOption(2);
            setSeleccionaDefault(false);
        } else if (guiaDestino.tipoDeRecoleccionDestino === 3) {
            setCampo('citaFueraHorario');
            setSelectedOption(3);
            setSeleccionaDefault(false);
        }
    }, [guiaDestino.tipoDeRecoleccionDestino, value, EsFueraHorario, valueHoraDe, valueHoraHasta, localStorage.getItem("idioma")]);

    useEffect(() => {
        if (ventanaFijaRequest || !(cliente.clienteConfiguracionVentanaServicio?.activo ?? false)) {
            return;
        }
        getVentanaFija().then(res => {
            setVentanaFija({
                horaInicio: { hours: res.horA_IN.hours, minutes: res.horA_IN.minutes },
                horaFin: { hours: res.horA_FIN.hours, minutes: res.horA_FIN.minutes },
                lun: res.lunes, mar: res.martes, mie: res.miercoles, jue: res.jueves, vie: res.viernes,
                sab: res.sabado, dom: res.domingo,
                ventanaEsp: res.ventanA_ESPANOL, ventanaIng: res.ventanA_INGLES
            });
            setVentanaFijaRequest(true);
            if (!(res.horA_IN.hours === 0 && res.horA_IN.minutes === 0 && res.horA_FIN.hours === 0 && res.horA_FIN.minutes === 0)) {
                setAplicaReglasVentana(true);
            }
        });
    }, [cliente.id, guiaDestino.distribuidor?.clienteDistribuidorID]);

    const seleccionarNormal = () => {
        onChange(aplicarEntregaNormalGuiaDestino(guiaDestino));
        setCampo('normal');
        setSelectedOption(1);
        setSeleccionaDefault(true);
    };

    const abrirDialogCita = () => {
        if (!validaInvitado() || !validaFechaCita()) {
            return;
        }
        setDialogFecha(true);
    };

    const saveFechaCita = async (fecha: Date | null) => {
        if (!fecha) {
            return;
        }
        const esValido = await validaMatriz(fecha);
        if (!esValido) {
            return;
        }
        if (validaFechaFueraHorario(fecha)) {
            enqueueSnackbar(traducirMessage(145), { variant: "warning" });
            return;
        }
        setValueCita(fecha);
        onChange(aplicarCitaEadGuiaDestino(guiaDestino, fecha));
        setCampo('cita');
        setSelectedOption(2);
        setSeleccionaDefault(false);
        setDialogFecha(false);
    };

    const abrirDialogFueraHorario = () => {
        if (!validaInvitado() || !validaFechaCita()) {
            return;
        }
        setDialogFechaFueraHorario(true);
    };

    const saveFechaFueraHorario = async (fecha: Date | null, horaDe: string | null, horaHasta: string | null) => {
        if (!fecha || !horaDe || !horaHasta) {
            return;
        }
        const esValido = await validaMatriz(fecha);
        if (!esValido) {
            return;
        }
        onChange(aplicarCitaFueraHorarioGuiaDestino(guiaDestino, fecha, horaDe, horaHasta));
        setCampo('citaFueraHorario');
        setSelectedOption(3);
        setSeleccionaDefault(false);
        setDialogFechaFueraHorario(false);
    };

    if (!areaServicio?.id) {
        return null;
    }

    const fechaString2 = new Date().toISOString().slice(0, 10).toString() + 'T00:00';

    return (<>
        <Box mt={4} mb={1} className="title-2">
            {traducirMessage(191)}
        </Box>
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <Help comments={traducirMessage(254)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption === 1 ? "#FFFFFF" : "#00653b" }} size="small" />
                <Box
                    className={`pointer card medium-height ${seleccionaDefault ? 'selected' : ''}`}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    style={{ padding: "10px 20px" }}
                    onClick={seleccionarNormal}
                >
                    <Box className="title-4 green-label text-center">
                        <b>{traducirMessage(234)}</b>
                    </Box>
                    <Box className="title-4 text-center" my={1}>
                        <b>{horarios?.map((h, i) => (<div key={i}>{h}</div>))}</b>
                    </Box>
                </Box>
            </Grid>

            {aceptaCita && <>
                <Grid item xs={12} md={4} lg={4}>
                    <Help comments={traducirMessage(252)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption === 2 ? "#FFFFFF" : "#00653b" }} size="small" />
                    <Grid container
                        className={`pointer card medium-height ${(seleccionaDefault || campo !== 'cita') ? '' : 'selected'}`}
                        justify="center" alignItems="center" style={{ padding: "10px 20px 10px 10px" }}
                        onClick={abrirDialogCita}
                    >
                        <Grid item xs={3}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Box><img src="image/icon-calendar.png" alt="icon" /></Box>
                            </Box>
                        </Grid>
                        <Grid item xs>
                            <Box display="flex" flexDirection="column" justifyContent="center">
                                <Box className="title-4 green-label" mb={1}><b>{fechaString}</b></Box>
                                <Box className="title-4" flexGrow={1}>{horaString}</Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} md={4} lg={4}>
                    <Help comments={traducirMessage(252)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption === 3 ? "#FFFFFF" : "#00653b" }} size="small" />
                    <Grid container
                        className={`pointer card medium-height ${(seleccionaDefault || campo !== 'citaFueraHorario') ? '' : 'selected'}`}
                        justify="center" alignItems="center" style={{ padding: "10px 20px 10px 10px" }}
                        onClick={abrirDialogFueraHorario}
                    >
                        <Grid item xs={3}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Box><img src="image/icon-calendar.png" alt="icon" /></Box>
                            </Box>
                        </Grid>
                        <Grid item xs>
                            <Box display="flex" flexDirection="column" justifyContent="center">
                                <Box className="title-4 green-label" mb={1}><b>{fechaStringFueraHorario}</b></Box>
                                <Box className="title-4" flexGrow={1}>{horaStringFH}</Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </>}
        </Grid>

        <PickUpDate
            abierto={dialogFecha}
            onClose={() => setDialogFecha(false)}
            minDate={fechaString2}
            onSave={saveFechaCita}
            value={valueCita ?? value}
            horarios={horarios}
            esOrigen={false}
            aplicaReglasVentana={aplicaReglasVentana}
            ventanaFija={ventanaFija}
            areaServicioRemitente={areaServicio}
            horariosAreaServicio={horarioArea}
            esSolicitud={true}
            esRecoleccionPuerto={esRecintoAduanal}
        />

        <PickUpDateFueraHorario
            abierto={dialogFechaFueraHorario}
            onClose={() => setDialogFechaFueraHorario(false)}
            minDate={fechaString2}
            onSave={saveFechaFueraHorario}
            value={valueCita ?? value}
            horarios={horarios}
            valueHoraDe={horaDeP}
            valueHoraHasta={horaHastaP}
            hor={horarioArea}
            esOrigen={false}
            horariosAreaServicio={horarioArea}
            aplicaReglasVentana={aplicaReglasVentana}
            ventanaFija={ventanaFija}
            areaServicioRemitente={areaServicio}
            esSolicitud={true}
            esRecoleccionPuerto={esRecintoAduanal}
        />

        {showLoading && <LoadingDialog titulo={traducirLabel(240)} abierto={true} />}
    </>);
};

export default RecoleccionFechaEntregaGuia;
